const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

// Callback opcional para tratamento global de 401 (registrado pelo router/store)
let onUnauthorized = null;

/**
 * Registra handler global para 401 (por exemplo: redirecionar para /login)
 */
export function setUnauthorizedHandler(handler) {
  onUnauthorized = handler;
}

/**
 * Base fetch wrapper with error handling
 */
async function fetchAPI(endpoint, options = {}) {
  const url = `${API_URL}${endpoint}`;

  const config = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    },
    credentials: 'include' // Important for session cookies
  };

  try {
    const response = await fetch(url, config);
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      // Tratamento específico para 401 (sessão expirada)
      if (response.status === 401 && onUnauthorized) {
        // Executar callback sem bloquear o throw original
        try { onUnauthorized(endpoint); } catch {}
      }

      // API returned error
      throw {
        status: response.status,
        ...data
      };
    }

    return data;
  } catch (error) {
    // Network error or parsing error
    if (error.status) {
      // API error - rethrow
      throw error;
    }

    // Network/parsing error
    throw {
      status: 0,
      error: 'NETWORK_ERROR',
      message: 'Não foi possível conectar ao servidor'
    };
  }
}

/**
 * HTTP methods
 */
const api = {
  get(endpoint, options) {
    return fetchAPI(endpoint, { ...options, method: 'GET' });
  },

  post(endpoint, body, options) {
    return fetchAPI(endpoint, {
      ...options,
      method: 'POST',
      body: body ? JSON.stringify(body) : undefined
    });
  },

  patch(endpoint, body, options) {
    return fetchAPI(endpoint, {
      ...options,
      method: 'PATCH',
      body: body ? JSON.stringify(body) : undefined
    });
  },

  delete(endpoint, options) {
    return fetchAPI(endpoint, { ...options, method: 'DELETE' });
  }
};

export { api };
export default api;
